// src/i18n/en/tags.js
const tags = {
    notifications: {
        pdf_downloaded: 'PDF downloaded successfully',
        pdf_error: 'Error generating PDF',
        qr_generation_error: 'Error generating QR code',
        sms_not_available: 'SMS service not available',
        phone_required: 'Phone number is required',
        sms_sent: 'SMS sent successfully',
        sms_error: 'Failed to send SMS',
        qr_not_ready: 'QR code is not ready',
        qr_copied: 'QR image copied to clipboard',
        code_copied: 'Code copied to clipboard',
    },
    download: {
        a4: 'Download A4',
        ticket: 'Download Ticket',
    },
    actions: {
        download_pdf: 'Download PDF',
        print: 'Print',
        share_qr: 'Share QR',
        copy_qr: 'Copy QR image',
        send_sms: 'Send SMS',
    },
    pdf: {
        locker_access_code: 'Locker Access Code',
        digital_locker_card: 'Digital Locker Card',
        instructions_title: 'Instructions for Use',
        instruction_1: 'Go to the locker area',
        instruction_2: 'Enter your code or scan the QR code',
        instruction_3: 'Your assigned locker will open automatically',
        environmental_message: 'Thank you!',
        contact_help: 'Need help? Contact our front desk'
    },
};

export default tags;
